import { AttachmentsRoot, AttachmentsList, AttachmentsUploadInput } from './ui';
export type { AttachmentsListRef } from './ui';

export const Attachments = {
  Root: AttachmentsRoot,
  UploadInput: AttachmentsUploadInput,
  List: AttachmentsList,
};
